import React from "react";
import { PersonPicker } from "components/common/PersonPicker";
import { SegmentedControl } from "components/common/SegmentedControl";
import type { McpPeriod } from "@/lib/api/organizations";
import type { UsageMember } from "./memberUsage";

export const PeriodSwitch: React.FC<{
  value: McpPeriod;
  onChange: (period: McpPeriod) => void;
}> = ({ value, onChange }) => (
  <div className="h-6">
    <SegmentedControl<McpPeriod>
      options={[
        { value: "current", label: "This period" },
        { value: "previous", label: "Previous period" },
      ]}
      value={value}
      onChange={onChange}
    />
  </div>
);

export const MemberFinder: React.FC<{
  members: UsageMember[];
  selectedId: string | null;
  onSelect: (clientId: string | null) => void;
  label: string;
}> = ({ members, selectedId, onSelect, label }) => (
  <PersonPicker
    directory={members.map((m) => m.person)}
    selected={members.find((m) => m.clientId === selectedId)?.person ?? null}
    onSelect={(person) =>
      onSelect(
        members.find((m) => m.person.email === person?.email)?.clientId ?? null,
      )
    }
    placeholder={`${label}…`}
    ariaLabel={label}
  />
);
